'use strict';
/**
 * @function
 * @description Dictates the functions of the back to top button
 */
var backtotop = {
	init: function () {

			// browser window scroll (in pixels) after which the "back to top" link is shown
		var offset = 500,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offsetOpacity = 2000,
			//duration of the top scrolling animation (in ms)
			scrollTopDuration = 700,
			//grab the "back to top" link
			$backToTop = $('.cd-top');

		//hide or show the "back to top" link
		$(window).scroll(function () {
			if ($(this).scrollTop() > offset) {
				$backToTop.addClass('cd-is-visible');
			} else {
				$backToTop.removeClass('cd-is-visible cd-fade-out');
			}
			if ($(this).scrollTop() > offsetOpacity) {
				$backToTop.addClass('cd-fade-out');
			}
		});

		//smooth scroll to top
		$backToTop.on('click', function (event) {
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0
			}, scrollTopDuration);
		});

		$backToTop.on('touchstart', function () {
			$(this).children('.up-arrow').addClass('backtotop-hover');
			$(this).children('.up-arrow').removeClass('backtotop-hoveroff');
		});
		$backToTop.on('touchend', function () {
			$(this).children('.up-arrow').removeClass('backtotop-hover');
			$(this).children('.up-arrow').addClass('backtotop-hoveroff');
		});

		function isIE(version, comparison) {
			var cc = 'IE',
				b = document.createElement('B'),
				docElem = document.documentElement,
				isInternetExplorer;
			if (version) {
				cc += ' ' + version;
				if (comparison) {
					cc = comparison + ' ' + cc;
				}
			}
			b.innerHTML = '<!--[if ' + cc + ']><b id="iecctest"></b><![endif]-->';
			docElem.appendChild(b);
			isInternetExplorer = !!document.getElementById('iecctest');
			docElem.removeChild(b);
			return isInternetExplorer;
		}
		if (isIE(10, 'lte')) {
			$(window).scroll(function () {
				if (($(this).scrollTop() > offset)) {
					$backToTop.fadeTo('fast', 1, function () {});
				} else {
					$backToTop.removeClass('cd-is-visible');
				}
				if ($(this).scrollTop() > offsetOpacity) {
					$backToTop.fadeTo('fast', 0.3, function () {});
				}
			});
		}
		this.rightPosition();
		$(window).smartresize(this.rightPosition);
	},

	rightPosition: function () {
		var distance = (window.innerWidth - $('#main').width()) / 2;
		$('.cd-top').css('right', distance + 'px').css('top', '515px');
	}
};
module.exports = backtotop;